export interface ErrorExceptionModel {
    code: string;
    description: string;
    errorType: string;
    exceptionDetails: ErrorExceptionDetailModel[]
}

export interface ErrorExceptionDetailModel {
    code: string;
    component: string;
    description: string;
}

export const INVALID_TOKEN = 'DP0008';